import { EventName } from '@lit/react';
import { BlocksPrimaryNav } from 'blocks-nextjs/blocks-web-components/components/primary-nav/primary-nav';
import { BlocksNavSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

/**
 * @deprecated - This component `CatPrimaryNav` has been deprecated and the updated version will be available with name `CatPrimaryNavLabs`. New component will be found under labs folder from Minor Release 3.10.0, `CatPrimaryNav` will be removed in 5.0 major release.
 */

export const CatPrimaryNav = createComponent({
  react: React,
  tagName: 'cat-primary-nav',
  elementClass: BlocksPrimaryNav,
  events: {
    onBlNavSelect: 'bl-nav-select' as EventName<BlocksNavSelectEvent>
  }
});
